"use client"

import { SquareArrowOutUpRight } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareArrowOutUpRightIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareArrowOutUpRightIcon = component(Icon)({
  as: SquareArrowOutUpRight,
})
